'use client';

import { FacebookShareButton, XShareButton } from 'react-share';
import { useTranslation } from 'react-i18next';
import { Icon } from '@aqarmap/aqarmap-ui';
import Modal from '~/components/Modal';
import CopyButton from '~/components/CopyButton';

const ShareModel = ({ link }: { link: string }) => {
  const { t } = useTranslation('app');

  return (
    <div className="[&>dialog>div]:!w-[375px]">
      <Modal title={t('shareTitle')} modalKey="share" bodyClassName="ssss">
        <div className="flex flex-col gap-2x !w-full">
          <div className="flex flex-col gap-y-2x w-full ">
            <CopyButton text={link} />
          </div>
          <div className="w-full flex flex-row gap-x-2x">
            <div className="!border !border-gray rounded-[12px] flex-1">
              <FacebookShareButton
                url={`${process.env.NEXT_PUBLIC_BASE_URL}/${link}`}
                className="!border !border-gray rounded-[12px] flex items-center gap-1.5x !flex-1 !px-1.5x !py-2x !w-full"
                windowWidth={800}
              >
                <Icon name="facebook" />
                <span className="text-gray__dark_1">{t('facebook')}</span>
              </FacebookShareButton>
            </div>
            <div className="!border !border-gray rounded-[12px] flex-1">
              <XShareButton
                url={`${process.env.NEXT_PUBLIC_BASE_URL}/${link}`}
                className="!border !border-gray rounded-[12px] flex items-center gap-1.5x !flex-1 !px-1.5x !py-2x !w-full"
                windowWidth={800}
              >
                <Icon name="x-platform" />
                <span className="text-gray__dark_1">{t('twitter')}</span>
              </XShareButton>
            </div>
          </div>
          <p className="text-body-2 text-gray__dark_2 pb-3x pt-x">
            {t('shareDescription')}
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default ShareModel;
